import { css } from '@/styled-system/css';
import FullscreenOverlay from '../../../ui/FullscreenOverlay';
import { ModuleTrigger } from '../../../ui/ModuleTrigger';
import { useDetailPanel } from '../../../ui/DetailPanel';
import { NeighborhoodSpokeContent } from './NeighborhoodSpoke';
import { NeighborhoodSpoke } from './NeighborhoodSpoke';
import { NeighborhoodProvider } from './context';

const footerContainer = css({
  marginTop: '2x',
});

export const NeighborhoodFooter = () => {
  const { openPanel, isMobile } = useDetailPanel();

  if (!isMobile) {
    return (
      <div className={footerContainer}>
        <ModuleTrigger
          aria-label="Explore neighborhood & commute options"
          onClick={() => openPanel('neighborhood', NeighborhoodSpokeContent, { provider: NeighborhoodProvider })}
        >
          Explore neighborhood & commute
        </ModuleTrigger>
      </div>
    );
  }

  return (
    <div className={footerContainer}>
      <FullscreenOverlay.Root defaultOpen={false}>
        <FullscreenOverlay.Trigger asChild>
          <ModuleTrigger aria-label="Explore neighborhood & commute options">
            Explore neighborhood & commute
          </ModuleTrigger>
        </FullscreenOverlay.Trigger>

        <FullscreenOverlay.Portal>
          <FullscreenOverlay.Backdrop>
            <FullscreenOverlay.Content>
              <NeighborhoodSpoke />
            </FullscreenOverlay.Content>
          </FullscreenOverlay.Backdrop>
        </FullscreenOverlay.Portal>
      </FullscreenOverlay.Root>
    </div>
  );
};
